import React from 'react';
import { connect } from 'react-redux';
import { find } from 'lodash';
import { closeToast } from 'Store/toast/toast.actions';
import { endLoading, startLoading } from 'Store/global-loader/globalLoader.action';
import {
  fetchProposalsById,
  patchProposalHandler,
  saveCustomerProposalsHandler,
  displayToastOnContextShare,
  fetchRefreshProposal,
} from 'Store/booking/proposals/proposals.action';
import { selectProposal } from 'Store/booking/selected-proposal-id/selectedProposalId.action';
import {
  getCurrentResort,
  getProposals,
  getSelectedProposalId,
  getStreetViews,
} from 'Store/booking/booking.selector';
import { getBookingEngineI18n } from 'Store/cms/cms.actions';
import { getLeadScore } from 'Store/lead-info/leadInfo.selector';
import { fetchStreetViewsByAccommodationCategoryId } from 'Store/streetViews/streetViews.action';
import { STATIC_PAGE_TYPES } from 'Tracking/constants';
import errorBoundary from 'Components/hoc/errorBoundary/errorBoundary';
import { getDefaultProposal } from 'Utils/proposal/proposalUtils';
import { BOOKING_ENGINE_PAGE_ID } from 'Routes/constants';
import BookingEngine from './BookingEngine';
export const mapStateToProps = (state: ReduxState) => {
  // if there is neolids we have identified attendees so we map the proposals with the attendees datas
  const proposals = getProposals(state) || [];
  const resort = getCurrentResort(state);
  const streetViews = getStreetViews(state);
  return {
    i18n: state.cms,
    leadScore: getLeadScore(state),
    proposals,
    resort,
    selectedProposal:
      find(proposals, {
        id: getSelectedProposalId(state),
      }) || getDefaultProposal(proposals, resort),
    streetViews,
    tripInformation: state.tripInformation,
    userInfo: state.userInfo,
  };
};
export const mapDispatchToProps = {
  fetchProposalsById,
  fetchStreetViewsByAccommodationCategoryId,
  selectProposal,
  endLoading,
  startLoading,
  closeToast,
  patchProposalHandler,
  saveCustomerProposalsHandler,
  displayToastOnContextShare,
  getBookingEngineI18n,
  fetchRefreshProposal,
};
const BookingEngineContainer = errorBoundary(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    undefined, // because of shallow routing used inside the BE, the page changes without the props changing,
    // so redux prevents the re-rendering (why btw? There's a withRouter lower, this is still weird)
    {
      pure: false,
    },
  )(BookingEngine),
);
BookingEngineContainer.pageId = BOOKING_ENGINE_PAGE_ID;
BookingEngineContainer.pageType = STATIC_PAGE_TYPES.BE;
BookingEngineContainer.disableFooter = true;
BookingEngineContainer.disableHeader = true;
export default BookingEngineContainer;
